import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from '../../actions/accountDashboard';
import { CallHistory } from '../../types/CallHistory';
import { DiscountPlanList, GetAccountDashboardCallsPayload, PeersContactListItem, ProductInfo } from '../../actions/accountDashboard/payloads';
import { SipCall } from '../../actions/ringgroups/payloads';
import { RingGroupType } from '../../types/RingGroup';
import { CounterInterface } from '../../types/CustomerAgreementCondition';

export interface AccountDashboardStateType {
    isLoadingCalls?: boolean;
    totalCalls?: number;
    xdr_list?: CallHistory[];
    lastCallsPayload?: GetAccountDashboardCallsPayload;
    sipCallsList?: SipCall[];
    isLoadingRingGroups?: boolean;
    ringGroups?: RingGroupType[];
    isUpdatingCallForwardingSettings?: boolean;
    isLoadingProductInfo?: boolean;
    accountProductInfo?: ProductInfo;
    isLoadingCounters?: boolean;
    counters?: CounterInterface[];
    isLoadingAddon?: boolean;
    addonProducts?: DiscountPlanList[];
    isLoadingPeerContacts?: boolean;
    peerContacts?: PeersContactListItem[];
}

export const initialState: AccountDashboardStateType = {
    isLoadingCalls: false,
    sipCallsList: [],
    isUpdatingCallForwardingSettings: false,
    isLoadingProductInfo: false,
    isLoadingAddon: false,
};

export type AccountDashboardActionsType = ActionType<typeof actions>;

const accountDashboardReducer = createReducer<
    AccountDashboardStateType,
    AccountDashboardActionsType
>(initialState)
    .handleAction(actions.getAccountDashboardCalls.request, (state, action) => ({
        ...state,
        isLoadingCalls: true,
        lastCallsPayload: action.payload
    }))
    .handleAction(actions.getAccountDashboardCalls.success, (state, action) => ({
        ...state,
        isLoadingCalls: false,
        totalCalls: action.payload.history.total,
        xdr_list: [
            ...(state.lastCallsPayload?.offset == 0 ? [] : state.xdr_list ?? []),
            ...(action.payload.history.xdr_list ?? [])
        ],
        sipCallsList: action.payload.active?.calls_list ?? state.sipCallsList
    }))
    .handleAction(actions.getAccountDashboardCalls.failure, (state) => ({
        ...state,
        isLoadingCalls: false,
    }))
    .handleAction(actions.updateSipCallStatusForAccountDashboardByWebSocketEvent.success, (state, action) => ({
        ...state,
        sipCallsList: action.payload
    }))
    .handleAction(actions.recalcSipCallsDurationForAcoountDashboard.success, (state, action) => ({
        ...state,
        sipCallsList: action.payload
    }))
    .handleAction(actions.getAccountDashboardRingGroupList.request, (state) => ({
        ...state,
        isLoadingRingGroups: true,
        ringGroups: undefined
    }))
    .handleAction(actions.getAccountDashboardRingGroupList.success, (state, action) => ({
        ...state,
        isLoadingRingGroups: false,
        ringGroups: action.payload,
    }))
    .handleAction(actions.getAccountDashboardRingGroupList.failure, (state) => ({
        ...state,
        isLoadingRingGroups: false,
    }))
    .handleAction(actions.updateAccountDashboardCallForwardingSettings.request, (state) => ({
        ...state,
        isUpdatingCallForwardingSettings: true,
    }))
    .handleAction(actions.updateAccountDashboardCallForwardingSettings.success, (state) => ({
        ...state,
        isUpdatingCallForwardingSettings: false,
    }))
    .handleAction(actions.updateAccountDashboardCallForwardingSettings.failure, (state) => ({
        ...state,
        isUpdatingCallForwardingSettings: false,
    }))
    .handleAction(actions.getAccountProductInfo.request, (state) => ({
        ...state,
        isLoadingProductInfo: true,
        accountProductInfo: undefined,
    }))
    .handleAction(actions.getAccountProductInfo.success, (state, action) => ({
        ...state,
        isLoadingProductInfo: false,
        accountProductInfo: action.payload
    }))
    .handleAction(actions.getAccountProductInfo.failure, (state) => ({
        ...state,
        isLoadingProductInfo: false,
    }))
    .handleAction(actions.getAccountDashboardCounters.request, (state) => ({
        ...state,
        isLoadingCounters: true,
        counters: undefined,
    }))
    .handleAction(actions.getAccountDashboardCounters.success, (state, action) => ({
        ...state,
        isLoadingCounters: false,
        counters: action.payload
    }))
    .handleAction(actions.getAccountDashboardCounters.failure, (state) => ({
        ...state,
        isLoadingCounters: false,
    }))
    .handleAction(actions.getAccountDashboardDiscountPlanList.request, (state) => ({
        ...state,
        isLoadingAddon: true,
        addonProducts: undefined,
    }))
    .handleAction(actions.getAccountDashboardDiscountPlanList.success, (state, action) => ({
        ...state,
        isLoadingAddon: false,
        addonProducts: action.payload
    }))
    .handleAction(actions.getAccountDashboardDiscountPlanList.failure, (state) => ({
        ...state,
        isLoadingAddon: false,
    }))
    .handleAction(actions.getAccountDashboardPeersContactList.request, (state) => ({
        ...state,
        isLoadingPeerContacts: true,
    }))
    .handleAction(actions.getAccountDashboardPeersContactList.success, (state, action) => ({
        ...state,
        peerContacts: action.payload,
        isLoadingPeerContacts: false,
    }))
    .handleAction(actions.getAccountDashboardPeersContactList.failure, (state) => ({
        ...state,
        isLoadingPeerContacts: false,
    }))
    .handleAction(actions.clearCallRecordingIds.success, (state, action) => ({
        ...state,
        xdr_list: [
            ...(action.payload ?? [])
        ],
    }));

export default accountDashboardReducer;
